// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { headerStyles } from "@turnerBlueprint/Overrides/Pages/Header";
import { color, companyLogoItem, getSystemColor, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        display: block;
        margin: 0px auto;
        width: 100%;
        max-width: 100%;
        position: sticky;
        top: 0px;
        z-index: ${getProp("theme.zIndex.header")};

        ${xScreen("lt", "md")} {
            position: sticky;
        }

        ${xScreen("lt", "sm")} {
            position: sticky;
        }

        ${xScreen("gte", 1025)} {
            &.hide {
                visibility: hidden;
                opacity: 0;
            }
        }

    `,
};

headerStyles.container = {
    css: css`
        background-color: ${color("common.ui1")};

        ${({ isCheckoutPage }: any) =>
            isCheckoutPage &&
            `
            padding-top: 8px; 
            box-shadow: 0 1px 0 0 ${getSystemColor("common.border")};
        `}
    `,
};

headerStyles.mainNavigationContainer = {
    css: css`
        background-color: ${color("primary")};
    `,
};

headerStyles.printLogo = companyLogoItem;

headerStyles.printLogoImage = {
    css: css`
        display: block;
        max-width: 100%;
        object-fit: contain;
        ${BLUEPRINT_NAME === "turnerBlueprint"
            ? css`
                  height: 35px;
                  width: 277px;
              `
            : css`
                  height: 43px;
                  width: 227px;
              `}
    `,
};

headerStyles.websiteName = {
    css: css`
        @media print {
            display: block;
        }
        font-size: 12px;
        line-height: 14px;
        padding-left: 16px;
        display: none;
    `,
};
